import { AxiosResponse } from 'axios';
import VenueTypeDto from 'common/dto-types/venue-type-dto';
import axiosServices, { FiltersAndSortingParams, buildFilterParams } from 'utils/axios';

export const VENUE_TYPE_API_URL = '/venueTypes';

export const createVenueType = async (venueType: VenueTypeDto): Promise<AxiosResponse | null | undefined> => {
    try {
        return await axiosServices.post(VENUE_TYPE_API_URL, venueType);
    } catch (err) {
        const errorResponse = err as AxiosResponse;
        if (errorResponse) return errorResponse;
        return null;
    }
};

export const updateVenueType = async (venueType: VenueTypeDto): Promise<AxiosResponse | null | undefined> => {
    try {
        return await axiosServices.put(VENUE_TYPE_API_URL, venueType);
    } catch (err) {
        const errorResponse = err as AxiosResponse;
        if (errorResponse) return errorResponse;
        return null;
    }
};

export const deleteVenueType = async (id: number): Promise<AxiosResponse | null | undefined> => {
    try {
        return await axiosServices.delete(`${VENUE_TYPE_API_URL}/${id}`);
    } catch (err) {
        const errorResponse = err as AxiosResponse;
        if (errorResponse) return errorResponse;
        return null;
    }
};

export const fetchVenueTypeList = async (
    params: FiltersAndSortingParams,
): Promise<Array<VenueTypeDto> | null | undefined> => {
    try {
        const res = await axiosServices.get(`${VENUE_TYPE_API_URL}${buildFilterParams(params)}`);
        return res.data;
    } catch (err) {
        // TODO: Implement a proper way to handle errors
        // https://fifadigital.atlassian.net/browse/FMH-2075
        console.error(err);
        return null;
    }
};
